<template>
  <div>
    <v-card
      elevation="0"
      class="card card-mobile"
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label class="mx-5 my-5" style="color: #444444; font-size: 20px">
          {{ $t("versioncontrol") }}
        </label>
      </v-system-bar>
      <!-- ******** header, add new -->
      <div class="ml-7 mt-10">
        <v-btn width="230" color="#A6CC39" dark class="text-capitalize">
          {{ $t("versioncontrol") }}
        </v-btn>
      </div>
      <!-- <v-layout row="wrap" align-center>
        <v-flex my-5>
          <div class="company-title-div-mobile">
            <title-block
              :relative="$vuetify.breakpoint.name !== 'xs' ? true : false"
              top="1"
              left="2.6"
              width="300"
              height="60"
              class="company-title-text-mobile"
            >
              {{ $t("versioncontrol") }}</title-block
            >
          </div>
        </v-flex>
        <v-spacer />
      </v-layout> -->
      <!-- ******** header, add new -->

      <!-- ******** card x 2 -->
      <v-layout row="wrap" justify-center class="mx-7">
        <v-card
          style="
            width: 100%;
            background: #e1f4ec;
            box-shadow: 0px 2px 5px #0a0a0a80;
            border-radius: 5px;
          "
          class="px-5 my-4"
        >
          <v-layout row="wrap" style="padding-left: 2.6%" align-center>
            <v-flex shrink pr-5 mt-5 mb-5>
              <v-img
                class="AppLogo"
                src="@/assets/imgs/SeedAppiconWeb.png"
              ></v-img>
            </v-flex>
            <v-flex shrink pr-5 mt-5 mb-5 style="width: 210px">
              <v-flex shrink class="b-text"
                ><h6 style="color: #47484b">{{ $t("versionno") }}</h6></v-flex
              >
            </v-flex>
            <v-flex md4 lg3 x20 mt-5 mb-5 pr-5>
              <v-text-field
                solo
                dense
                v-model="versionNo"
                @keypress="isNumber($event)"
                class="versionTextField text"
                placeholder="Enter Version Number"
              ></v-text-field>
              <div v-if="version" style="color: red" class="text">
                Please Fill in Number Only.
              </div>
            </v-flex>
            <!-- <v-flex md3></v-flex> -->
            <v-flex md3 mt-5 mb-5>
              <v-btn
                @click="UpdateConfirm()"
                depressed
                color="#4CAF50"
                class="text"
                style="width:150px;height:43px;background-color:#6CC8A0;border-radius: 4px;color:white;text-transform:none;marg"
                >{{ $t("update") }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          style="
            width: 100%;
            background: #e1f4ec;
            box-shadow: 0px 2px 5px #0a0a0a80;
            border-radius: 5px;
          "
          class="px-5 my-4"
        >
          <v-layout row="wrap" style="padding-left: 2.6%" align-center>
            <v-flex shrink pr-5 mt-5 mb-5>
              <v-img
                class="AppLogo"
                src="@/assets/imgs/SeedAppiconWeb.png"
              ></v-img>
            </v-flex>
            <v-flex shrink pr-5 mt-5 mb-5 style="width: 210px">
              <v-flex shrink class="b-text"
                ><h6 style="color: #47484b">Seed Mobile Application</h6></v-flex
              >
            </v-flex>
            <!-- <v-flex md6></v-flex> -->
            <v-flex md3 mt-5 mb-5>
              <v-btn
                @click="forceresetDialog()"
                depressed
                color="#4CAF50"
                class="text"
                style="
                  width: 150px;
                  height: 43px;
                  background-color: #6cc8a0;
                  border-radius: 4px 4px;
                  color: white;
                  text-transform: none;
                "
                >{{ $t("forcereset") }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card>
      </v-layout>
      <!-- card x 2 ******** -->
    </v-card>

    <v-dialog v-model="versionControl" persistent max-width="550">
      <v-card style="border-radius: 25px">
        <v-layout row="wrap" align-center px-5 mx-5 py-5>
          <v-flex
            shrink
            v-if="update == true"
            class="title-text"
            style="color: #a6cc39; font-size: 30px"
          >
            {{ $t("updateversionno") }}
          </v-flex>
          <v-flex
            shrink
            v-else
            class="title-text"
            style="color: #a6cc39; font-size: 30px"
          >
            {{ $t("forcereset") }}
          </v-flex>
          <v-spacer />
          <!--   <v-flex shrink>
            <img
              src="@/assets/imgs/close.jpg"
              style="width: 16px; height:16px;cursor: pointer"
              @click="cancel"
            />
          </v-flex> -->
        </v-layout>
        <v-layout row="wrap" align-center px-5 mx-5>
          <v-flex
            shrink
            v-if="update == true"
            class="text"
            style="color: #4d4f5c; font-size: 18px"
            >{{ $t("doyouconfirmtoupdate") }} {{ versionNo }}?</v-flex
          >
          <v-flex
            shrink
            v-else
            class="text"
            style="color: #4d4f5c; font-size: 18px"
          >
            {{ $t("wouldyouliketoreset") }}
          </v-flex>
        </v-layout>
        <v-layout row="wrap" align-center px-5 mx-5 mt-3>
          <label
            class="text"
            v-if="update == true"
            style="color: #4d4f5c; font-size: 16px"
            >{{ $t("versionno") }}</label
          >
          <v-spacer></v-spacer>
          <v-spacer />
        </v-layout>
        <v-layout row="wrap" align-center px-5 mx-4>
          <v-flex shrink style="width: 500px" v-if="update == true">
            <v-text-field
              outlined
              dense
              v-model="versionNoPopUp"
              @keypress="isNumber2($event)"
              class="versionPopupTextField"
            ></v-text-field>
            <div
              v-if="version2"
              style="color: red; font-family: Dbx; font-size: 23px"
            >
              Please Fill in Number Only.
            </div>
          </v-flex>
          <v-flex shrink style="width: 500px" v-else>
            <v-text-field
              outlined
              dense
              v-model="ResetConfirmText"
              class="versionPopupTextField"
            ></v-text-field>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout row="wrap" align-center px-2 mx-7 py-3>
          <v-flex md6></v-flex>
          <v-flex md3 pr-3>
            <v-btn
              block
              class="ma-2"
              text
              @click="cancel"
              color="#707070;"
              style="color: #707070; text-transform: none"
              >{{ $t("cancel") }}</v-btn
            >
          </v-flex>
          <v-flex md3 pl-3>
            <v-btn
              block
              depressed
              @click="ForceVersionUpdate_Reset"
              color="#6CC8A0"
              style="color: white; text-transform: none"
              >{{ $t("save") }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GlobalMixin from "../Mixins/GlobalMixin";
import axios from "axios";
import enurl from "@/api/environment";
import store from "@/store";
// import TitleBlock from "@/components/global_component/TitleBlock";
export default {
  mixins: [GlobalMixin],
  components: {
    // TitleBlock
  },
  data() {
    return {
      versionNo: "",
      versionNoPopUp: "",
      size: "48",
      versionControl: false,
      url: enurl.apiUrl,
      updateUsername: store.getters.username,
      companyID: store.getters.companyid,
      createUsername: "",
      currentAppVersion: "",
      resetDialog: false,
      update: false,
      update_reset: "",
      confirmText: "",
      ResetConfirmText: "",
      version: false,
      version2: false
    };
  },

  methods: {
    UpdateConfirm() {
      this.versionControl = true;
      this.confirmText = `Do you confirm to update version number to
                  ${this.versionNo}?`;
      this.update = true;
      this.update_reset = "update";
    },
    forceresetDialog() {
      this.versionControl = true;
      this.confirmText =
        "If you would like the system to force reset for all users please fill 'Confirm' in the field below";
      this.update = false;
      this.update_reset = "reset";
    },
    cancel() {
      this.versionControl = false;
      this.versionNoPopUp = "";
      this.version = false;
    },
    ForceVersionUpdate_Reset() {
      let self = this;
      if (self.update) {
        if (self.versionNoPopUp) {
          if (self.versionNoPopUp == self.versionNo) {
            let tempData = {
              versionNumber: self.versionNo,
              createBy: self.createUsername,
              updateBy: self.updateUsername
            };
            axios
              .post(`${self.url}Version/UpdateVersion`, tempData)
              .then(function(response) {
                if (response.data.status == 0) {
                  self.versionControl = false;
                  window.location.reload();
                  alert(response.data.message);
                }
                // self.add_log(
                //   "-", //phonemodal
                //   "Version Update", //description
                //   "Medium", //logType
                //   "ForceVersionUpdate_Reset", //methodName
                //   "", //exception
                //   "", //logTrace
                //   47 //correctionID
                // );
              })
              .catch(function(error) {
                // self.add_log(
                //   "-", //phonemodal
                //   "Version Update Fail", //description
                //   "Critical", //logType
                //   "ForceVersionUpdate_Reset", //methodName
                //   error.message, //exception
                //   JSON.stringify(error), //logTrace
                //   47 //correctionID
                // );
              });
          } else {
            alert(
              "The version number you entered in the previous step does not match this version number. Please check"
            );
          }
        } else {
          alert("Please Fill Version Number!");
        }
      } else {
        if (self.ResetConfirmText.toLowerCase() == "confirm") {
          axios
            .post(`${self.url}EmployeeEXT/UpdateForceResetProduct`)
            .then(function(response) {
              if (response.data.status == 0) {
                self.versionControl = false;
                alert(response.data.message);
                window.location.reload();
              }
              // self.add_log(
              //   "-", //phonemodal
              //   "Version Reset", //description
              //   "Medium", //logType
              //   "ForceVersionUpdate_Reset", //methodName
              //   "", //exception
              //   "", //logTrace
              //   47 //correctionID
              // );
            })
            .catch(function(error) {
              self.add_log(
                "-", //phonemodal
                "Version Reset Fail", //description
                "Critical", //logType
                "ForceVersionUpdate_Reset", //methodName
                error.message, //exception
                JSON.stringify(error), //logTrace
                47 //correctionID
              );
            });
        }
      }
    },
    getAppData() {
      let self = this;
      axios
        .get(
          " https://staging-api.jarvizapp.com/api/v4/Version/GetAppVersionAndroid"
        )
        .then(function(response) {
          // self.createUsername = response.data.data[0].createBy;
          self.currentAppVersion = response.data.data;
          // self.add_log(
          //   "-", //phonemodal
          //   "GetAppData", //description
          //   "Critical", //logType
          //   "getAppData", //methodName
          //   "", //exception
          //   "", //logTrace
          //   56 //correctionID
          // );
        })
        .catch(function(error) {
          // self.add_log(
          //   "-", //phonemodal
          //   "Cannot get app data", //description
          //   "Critical", //logType
          //   "getAppData", //methodName
          //   error.message, //exception
          //   JSON.stringify(error), //logTrace
          //   56 //correctionID
          // );
        });
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      // console.log(charCode);
      if (
        (charCode == 8 || (charCode > 47 && charCode < 58) || charCode == 46) &&
        charCode != 101
      ) {
        this.version = false;
        return true;
      } else {
        this.version = true;
        evt.preventDefault();
      }
    },
    isNumber2(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      // console.log(charCode);
      if (
        (charCode == 8 || (charCode > 47 && charCode < 58) || charCode == 46) &&
        charCode != 101
      ) {
        this.version2 = false;
        return true;
      } else {
        this.version2 = true;
        evt.preventDefault();
      }
    },
    forceReset() {}
  },

  mounted() {
    this.getAppData();
  }
};
</script>

<style scoped>
.versionPopupTextField {
  height: 46px;
  border-radius: 10px;
}
.jv-breadcrumb {
  background-color: #13322c;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  border-radius: 0;
  border: none;
}
.jv-breadcrumb p {
  padding: 15px 10px;
}
.btnSetting {
  margin: 2rem 4rem;
  padding: 1rem 2rem;
  background: #e8ebea;
}
@media only screen and (max-width: 600px) {
  .btnSetting {
    margin: 2rem 2rem;
  }
}
.AppLogo {
  width: 100px;
  height: 100px;
}

.labeltext {
  color: #145829;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
}
</style>
<style>
.versionPopupTextField input {
  text-align: center;
}
.versionTextField.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9ec;
  border-radius: 5px;
  box-shadow: none;
  width: 100%;
}
.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  min-height: 45px !important;
}
.mdi-window-close:hover {
  color: red !important;
}

@media only screen and (max-width: 768px) {
  .card-mobile {
    margin-left: 1rem !important;
  }
}

@media only screen and (max-width: 414px) {
  .company-title-div-mobile {
    padding: 15%;
    margin: 0;
    margin-left: 2px;
  }

  .company-title-text-mobile {
    width: 130% !important;
  }
}

@media only screen and (max-width: 375px) {
  .company-title-div-mobile {
    padding: 15%;
    margin: 0;
    margin-left: 2px;
  }

  .company-title-text-mobile {
    width: 130% !important;
  }
}

@media only screen and (max-width: 320px) {
  .company-title-div-mobile {
    padding: 15%;
    margin: 0;
    margin-left: 2px;
  }

  .company-title-text-mobile {
    width: 130% !important;
  }
}
</style>
